import { setDayjsLocale } from '#helpers';
import type { AvailableLanguagesType, CustomDateType } from '@carrefour-gcs/shared';
import { LANGUAGE_DEFAULT, LANGUAGE_RESOURCES } from '@carrefour-gcs/shared';
import type { Locale } from 'date-fns';
import i18next from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { useTranslation } from 'i18next-vue';
import { ref, watch, type Ref } from 'vue';
import { LANGUAGE_LOCAL_MAP } from './constants/languageLocaleMap.constant';

i18next.use(LanguageDetector).init({
  fallbackLng: LANGUAGE_DEFAULT,
  detection: {
    order: ['localStorage', 'navigator'],
    caches: ['localStorage'],
    lookupFromPathIndex: 0
  },
  resources: LANGUAGE_RESOURCES
});

export default i18next;

/**
 * @deprecated Use `useLanguage().setLanguage` instead.
 */
export function changeLanguage(lang: AvailableLanguagesType) {
  setDayjsLocale(lang);
  i18next.changeLanguage(lang);
}

export function formatDateToLocale(date: Date): string {
  return date.toLocaleDateString(i18next.language, {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric'
  });
}

export function formatCustomDateToLocaleFR(customDate: CustomDateType): string {
  const { year, month, day } = customDate;
  return new Date(year, month - 1, day).toLocaleDateString('fr-FR', {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric'
  });
}
/**
 * @deprecated Use `useLanguage().language` instead.
 */
export function useCurrentLang(): Ref<AvailableLanguagesType> {
  const { i18next } = useTranslation();
  const currentLang = ref(i18next.resolvedLanguage as AvailableLanguagesType);
  watch(
    () => i18next.resolvedLanguage,
    (resolvedLanguage) => {
      currentLang.value = resolvedLanguage as AvailableLanguagesType;
    }
  );
  return currentLang;
}

function getLanguage(): AvailableLanguagesType {
  return (i18next.resolvedLanguage as AvailableLanguagesType) ?? LANGUAGE_DEFAULT;
}

export function getLocale(): Locale {
  return LANGUAGE_LOCAL_MAP[getLanguage()];
}
